export default __webpack_public_path__ + "static/media/Wolf@2x.62b78fbf.png";